import deepFreeze from '@/helpers/deepFreeze'
import { Mutation } from 'vuex'
import { ArticleState } from '../types'

const setArticle: Mutation<ArticleState> = (state, payload) => {
  state.activeArticle = deepFreeze(payload)
}

export default setArticle
